<template>
    <div>
        <form-header title="Onlineanmeldung" subtitle :tag="this.tag"></form-header>
        <ValidationObserver ref="form">
            <div id="printform">
                <div class="bg-primary">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <transition name="fade">
                            <div class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                                v-show="formbehaviour.alertrequired">
                                <div class="md:grid md:grid-cols-1 md:gap-3">
                                    <div class="md:col-span-1">
                                        <h3 class="leading-3">
                                            Bitte überprüfen Sie Ihre Eingabe!
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </transition>
                       
                        <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" v-if="this.fortbildungtype.toLowerCase() != 'tg'">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1" v-if="this.usedGroups.length > 0">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        Kurskatalog
                                    </h3>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Bitte wählen Sie die
                                        Fortbildungstermine. Klicken Sie dazu
                                        auf den jeweiligen Termin, für welchen
                                        Sie Ihre Anmeldung vornehmen möchten.
                                    </p>
                                    <text-input v-model="formdata.quicksearch" label placeholder="Suche" columns="1"
                                        class="mt-3"></text-input>
                                    <h3 class="text-lg font-medium leading-6 text-gray-900 mt-6 mb-4">
                                        Kategoriefilter
                                    </h3>
                                    <div class="border-gray-300 py-2 border text-sm text-black rounded-md text-center w-3/4 cursor-pointer"
                                        @click="formdata.selectedGroup = null" :class="{
                                            'bg-green-300 text-green-800':
                                                formdata.selectedGroup == null,
                                        }">
                                        Alle
                                    </div>
                                    <div v-for="(group, index) in this
                                        .usedGroups" :key="index"
                                        class="border-gray-300 py-2 border text-sm text-black rounded-md text-center w-3/4 cursor-pointer mt-2"
                                        @click="
                                            formdata.selectedGroup = group.id
                                            " :class="{
        'bg-green-300 text-green-800':
            formdata.selectedGroup ==
            group.id,
    }">
                                        {{ group.name }}
                                    </div>
                                </div>
                                <div class="md:mt-0"
                                    :class="[this.usedGroups.length > 0 ? 'mt-5 md:col-span-2' : 'md:col-span-3']">
                                    <div class="grid grid-cols-6 gap-6">
                                        <div class="col-span-6">
                                            <ul class="grid grid-cols-1 gap-3 sm:grid-cols-3">
                                                <li v-for="(fortbildung,
                                                    index) in this
        .filteredCatalog" :key="index"
                                                    class="bg-white border rounded-lg shadow-lg flex flex-row"
                                                    :class="[fortbildung.module.length > 0 ? 'col-span-3' : 'col-span-1']">
                                                    <div :class="[fortbildung.module.length > 0 ? '' : 'w-full']">
                                                        <div v-if="getGroupName(fortbildung.gruppenId)"
                                                            class="w-full flex items-center justify-between p-4 bg-indigo-200"
                                                            :class="[fortbildung.module.length > 0 ? 'rounded-br-xl' : '']">
                                                            <div class="items-center w-full text-center">
                                                                <div>
                                                                    <span
                                                                        class="px-2 py-1 bg-indigo-200 text-xs leading-4 text-indigo-800 rounded-sm text-center"
                                                                        >
                                                                        {{
                                                                            getGroupName(
                                                                                fortbildung.gruppenId
                                                                            )
                                                                        }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="w-full flex items-center justify-between p-4">
                                                            <div class="items-center w-full text-center">
                                                                <span
                                                                    class="text-center text-gray-900 break-normal text-sm w-full">
                                                                    {{
                                                                        fortbildung.name
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="border-t border-b border-gray-200" v-for="(termin,
                                                                i) in fortbildung.termine" :key="i">
                                                            <div class="-mt-px flex">
                                                                <div class="w-0 flex-1 flex border-gray-200">
                                                                    <div class="relative w-0 flex-1 inline-flex items-center justify-center text-xs text-gray-700 border border-transparent cursor-pointer"
                                                                        :class="{
                                                                            'bg-green-300':
                                                                                termin.isSelected,
                                                                            'rounded-r-lg':
                                                                                fortbildung.module.length > 0
                                                                        }" @click="
    termin.isSelected = !termin.isSelected
    ">
                                                                        <span class="ml-3 my-1">
                                                                            {{
                                                                                termin.zeitraum
                                                                            }}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="fortbildung.module.length > 0"
                                                        class="p-2 flex flex-col gap-2">
                                                        <span class="text-right pr-1 underline">Module</span>
                                                        <div v-for="module, index in fortbildung.module" :key="index"
                                                            class="rounded-lg border text-sm flex flex-col gap-1 py-2 ml-2">
                                                            <div class="px-2">{{ module.name }}</div>
                                                            <div class="text-xs text-right ml-2"><span
                                                                    class="bg-indigo-200 px-2 py-0.5 rounded-l-lg">{{ getZeitraum(module) }}</span></div>

                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form-section title="Angaben zur Teilnehmerin/zum Teilnehmer"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus.">
                            <drop-down :values="[
                                { id: 1, name: 'Herr' },
                                { id: 2, name: 'Frau' },
                                { id: 3, name: 'Divers' },
                            ]" v-model="anmeldung.teilnehmer.anrede" label="Anrede" rules="required"
                                columns="2"></drop-down>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input v-model="anmeldung.teilnehmer.prefix" label="Titel (vorangestellt)"
                                columns="2"></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input v-model="anmeldung.teilnehmer.vorname" label="Vorname" columns="3"
                                rules="required"></text-input>
                            <text-input v-model="anmeldung.teilnehmer.nachname" label="Nachname" columns="3"
                                rules="required"></text-input>
                            <text-input v-model="anmeldung.teilnehmer.suffix" label="Titel (nachgestellt)"
                                columns="2"></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input v-model="anmeldung.teilnehmer.berufstitel" label="Berufstitel"
                                columns="3"></text-input>
                            <div class="col-span-0 sm:col-span-3">&nbsp;</div>
                            <text-input v-model="anmeldung.teilnehmer.geburtsdatum" label="Geburtsdatum"
                                placeholder="z.B. 14.03.2008" columns="2" rules="required|date"></text-input>
                            <text-input v-model="anmeldung.teilnehmer.strasse" label="Straße, Hausnummer" columns="5"
                                tooltip="bitte die Meldeadresse angeben" rules="required"></text-input>
                            <text-input v-model="anmeldung.teilnehmer.plz" label="Postleitzahl" columns="2"
                                tooltip="bitte die Meldeadresse angeben" rules="required|numeric|length:4"></text-input>
                            <text-input v-model="anmeldung.teilnehmer.ort" label="Ort" columns="4"
                                tooltip="bitte die Meldeadresse angeben" rules="required"></text-input>
                            <text-input v-model="anmeldung.teilnehmer.email" rules="required|email" label="E-Mail"
                                columns="3"></text-input>
                            <text-input v-model="anmeldung.teilnehmer.telefon" rules="required|numeric"
                                label="Telefonnummer" columns="3"></text-input>
                        </form-section>

                        <form-section v-if="showNaechtigung()" title="Nächtigung"
                            subtitle="Machen Sie bitte Angaben zur benötigten Nächtigung.">
                            <div class="col-span-6 sm:col-span-5">
                                <fieldset class="mt-6">
                                    <radio-button-list title="Nächtigung wird benötigt:" subtitle
                                        v-model="anmeldung.naechtigungBenoetigt" :options="{
                                            Ja: 1,
                                            Nein: 0,
                                        }"></radio-button-list>
                                </fieldset>
                            </div>
                            <div class="col-span-6" v-show="anmeldung.naechtigungBenoetigt == 1">
                                <fieldset>
                                    <radio-button-list title="Zimmerkategorie" subtitle v-model="anmeldung.zimmerkategorie"
                                        :rules="anmeldung.naechtigungBenoetigt == 1
                                                ? 'required'
                                                : ''
                                            " :options="{
        Einzelzimmer: 865250000
    }"></radio-button-list>
                                </fieldset>
                            </div>
                            <text-input v-model="anmeldung.naechtigungVon" label="Nächtigung von" type="date"
                                placeholder="z.B. 14.09.2020" columns="2" :rules="anmeldung.naechtigungBenoetigt == 1
                                        ? 'required'
                                        : ''
                                    " maxdate="2026-09-01" mindate="2026-08-29" v-show="anmeldung.naechtigungBenoetigt == 1"></text-input>
                            <text-input v-model="anmeldung.naechtigungBis" label="bis" type="date" placeholder="z.B. 16.09.2020"
                                columns="2" maxdate="2026-09-02" mindate="2026-08-30" :rules="anmeldung.naechtigungBenoetigt == 1
                                        ? 'required'
                                        : ''
                                    " v-show="anmeldung.naechtigungBenoetigt == 1"></text-input>
                        </form-section>

                        <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">Wird die Rechnung von der Musikschule/der Gemeinde übernommen?</h3>
                                    <button @click="formbehaviour.abweichendeRechnungsadresse = true" type="button" class="
                                                w-20
                                                py-1
                                                text-base
                                                font-medium
                                                rounded-l-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                                mt-2
                                            "
                                        :class="[formbehaviour.abweichendeRechnungsadresse ? 'bg-green-600' : 'bg-gray-400']">
                                        Ja
                                    </button>
                                    <button @click="formbehaviour.abweichendeRechnungsadresse = false" type="button" class="
                                                items-center
                                                py-1
                                                w-20
                                                text-base
                                                font-medium
                                                rounded-r-md
                                                text-white
                                                text-center
                                                hover:opacity-75
                                            "
                                        :class="[!formbehaviour.abweichendeRechnungsadresse ? 'bg-green-600' : 'bg-gray-400']">
                                        Nein
                                    </button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6 items-end" v-if="formbehaviour.abweichendeRechnungsadresse">
                                         <text-area-input label="Rechnungsadresse" v-model="anmeldung.abweichendeRechnungsadresse" columns="6"
                                rows="5"></text-area-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form-section title="Zusätzliche Angaben" subtitle="" v-if="this.fortbildungtype.toLowerCase() == 'tg'">
                            <text-area-input label="Ich nehme am FORUM:EXPERTISE Vernetzungstreffen folgender Fachgruppe (z.B. Holzblasinstrumente, Musikkunde, Gesang, …) teil." v-model="anmeldung.vernetzungstreffen" columns="6"
                                rows="5"></text-area-input>
                                <div class="col-span-6 sm:col-span-5">
                                <fieldset class="mt-6">
                                    <radio-button-list title="Ich nehme am Abendessen teil" subtitle
                                        v-model="anmeldung.abendessen" :options="{
                                            Ja: 1,
                                            Nein: 0,
                                        }"></radio-button-list>
                                </fieldset>
                            </div>
                            <div class="col-span-6 sm:col-span-5">
                                <fieldset class="mt-6">
                                    <radio-button-list title="Ich benötige einen Shuttle-Service (Bahnhof Amstetten ↔ Schloss Zeillern)" subtitle
                                        v-model="anmeldung.shuttleservice" :options="{
                                            Ja: 1,
                                            Nein: 0,
                                        }"></radio-button-list>
                                </fieldset>
                            </div>
                        </form-section>

                        <form-section title="Anmerkungen" subtitle="Haben Sie sonstige Anmerkungen zu Ihrer Anmeldung?">
                            <text-area-input label="Anmerkungen" v-model="anmeldung.anmerkungen" columns="6"
                                rows="5"></text-area-input>
                        </form-section>

                        <form-section title="Angaben zur Institution/Fach"
                            subtitle="Bitte wählen Sie Ihre Institution aus.">
                            <drop-down :values="formdata.musikschulen" v-model="anmeldung.musikschuleId"
                                :label="getLabelForInstitution()" :rules="anmeldung.anderemusikschule
                                        ? ''
                                        : 'required'
                                    " columns="5"></drop-down>
                            <text-input v-model="anmeldung.anderemusikschule" v-if="showAndereInstitution()"
                                label="oder andere Musikschule / Kreativakademie / Institution" columns="3" :rules="anmeldung.musikschuleId ? '' : 'required'
                                    "></text-input>
                            <drop-down :values="formdata.instrumente" v-model="instrumenteId" label="Instrumente / Fächer"
                                columns="5"></drop-down>
                            <div class="col-span-6">
                                <span v-for="(id, index) in anmeldung.instrumente" :key="index"
                                    class="inline-flex items-center mr-1 px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-100 text-indigo-800">
                                    {{
                                        formdata.instrumente.find(
                                            instrument => instrument.id == id
                                        ).name
                                    }}
                                    <button type="button" @click="removeInstrument(id)"
                                        class="flex-shrink-0 -mr-0.5 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
                                        aria-label="Remove large badge">
                                        <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                                            <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                                        </svg>
                                    </button>
                                </span>
                            </div>
                            <text-input v-model="anmeldung.andereinstrumente" label="andere Instrumente / Fächer" :rules="anmeldung.instrumente.length > 0
                                    ? ''
                                    : 'required'
                                " columns="4"></text-input>
                        </form-section>

                        <form-section title="Hinweise" subtitle="" v-if="this.formdata.textbloecke.length > 0">
                            <div class="col-span-6 sm:col-span-5">
                                <div v-for="(tb, index) in this.formdata
                                    .textbloecke" :key="index" class="mb-4">
                                    <div class="text-md font-normal">{{ tb.identifier }}</div>
                                    <span class="text-sm font-normal mt-2 text-gray-500">{{ tb.content }}</span>
                                </div>
                            </div>
                        </form-section>

                        <form-section title="Informationspflicht" subtitle="gem. Art. 13 DSGVO">
                            <div class="col-span-6 sm:col-span-5">
                                <text-block :content="textbausteinfuer(
                                    'allgemein.informationspflicht'
                                )
                                    " />
                            </div>
                        </form-section>

                        <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="openSubmitModal()" v-if="this.anzahltermine > 0" type="button"
                                                class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                                v-html="this.fortbildungtype.toLowerCase() == 'kd' ? 'Anmeldung zum Coaching senden' : 'Anmeldung für ' + this.anzahltermine + ' Termine senden'">
                                            </button>
                                            <span v-if="this.anzahltermine == 0"
                                                class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-600 hover:bg-gray-500">
                                                Bitte wählen sie mindestens
                                                einen Termin aus.
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>

        <transition name="fade">
            <div v-show="formbehaviour.showSendModal"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.showSendModal" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.showSendModal && !formbehaviour.sending"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6">
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Wollen Sie die Anmeldung absenden?
                            </h3>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                            <button @click="sendAnmeldung()" type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                Absenden
                            </button>
                        </span>
                        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
                            <button @click="formbehaviour.showSendModal = false" type="button"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                Zurück
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
                <div v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p class="text-sm leading-5 font-medium text-gray-900">
                                        Validierung erfolgreich.
                                    </p>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.successful" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6">
                    <div>
                        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                            <svg class="h-6 w-6 text-green-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Sie haben sich erfolgreich angemeldet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Sie können dieses Fenster nun schließen.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="formbehaviour.showNoModules"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div 
                    class="bg-white rounded-lg px-4 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6">
                    <div>
                        
                        <div class="text-center">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Derzeit sind für dieses Programm keine Anmeldungen möglich.
                            </h3>
                            
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import FormSection from '@/components/forms/FormSection.vue'
import FormHeader from '@/components/forms/FormHeader.vue'

import TextInput from '@/components/inputs/TextInput.vue'
import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        fortbildungtype: {
            type: String,
            required: true,
        },
    },
    components: {
        TextInput,
        TextAreaInput,
        CheckBox,
        DropDown,
        FormSection,
        FormHeader,
        RadioButtonList,
        TextBlock,
    },
    data: function () {
        return {
            formbehaviour: {
                showSendModal: false,
                alertrequired: false,
                sending: false,
                successful: false,
                showNoModules: false,
                abweichendeRechnungsadresse: false,
            },
            formdata: {
                musikschulen: [],
                instrumente: [],
                fortbildungen: [],
                fortbildungsgruppen: [],
                textbloecke: [],
                quicksearch: null,
                selectedGroup: null,
            },
            anmeldung: {
                teilnehmer: {
                    anrede: null,
                    prefix: null,
                    vorname: null,
                    nachname: null,
                    suffix: null,
                    berufstitel: null,
                    geburtsdatum: null,
                    strasse: null,
                    plz: null,
                    ort: null,
                    email: null,
                    telefon: null,
                    anderesTelefon: null,
                },
                musikschuleId: null,
                anderemusikschule: null,
                andereinstrumente: null,
                datenveroeffentlichen: false,
                instrumente: [],
                naechtigungBenoetigt: 0,
                zimmerkategorie: 865250000,
                naechtigungVon: null,
                naechtigungBis: null,
                abweichendeRechnungsadresse: null,
                anmerkungen: null,
                anmeldungen: [],
            },
            instrumenteId: null,
        }
    },
    watch: {
        instrumenteId: function (newvalue, oldvalue) {
            if (newvalue && this.anmeldung.instrumente.indexOf(newvalue) < 0) {
                this.anmeldung.instrumente.push(newvalue)
            }

            this.instrumenteId = null
        },
    },
    computed: {
        tag() {
            switch (this.fortbildungtype.toLowerCase()) {
                case 'fw':
                    return 'Fortbildungswoche'
                case 'jf':
                    return 'Jahresfortbildung'
                case 'lf':
                    return 'FORUM:LEITENDE Fortbildungen'
                case 'kd':
                    return 'KUKUDU-Coaching®'
                case 'tg':
                    return 'Tagung'
                case 'fe':
                    return 'Forum:Expertise'
                default:
                    return ''
            }
        },
        anzahltermine() {
            var count = 0
            this.formdata.fortbildungen.forEach(fb => {
                fb.termine.forEach(termin => {
                    if (termin.isSelected) count++
                })
            })
            return count
        },
        usedGroups() {
            var used = this.formdata.fortbildungsgruppen.filter(el =>
                this.formdata.fortbildungen.find(fb => fb.gruppenId == el.id)
            )

            return used
        },
        filteredCatalog() {
            if (
                !this.formdata.quicksearch ||
                this.formdata.quicksearch.trim() == ''
            )
                return this.formdata.fortbildungen.filter(
                    fb =>
                        this.formdata.selectedGroup == null ||
                        fb.gruppenId == this.formdata.selectedGroup
                )

            return this.formdata.fortbildungen.filter(
                el =>
                    (this.formdata.selectedGroup == null ||
                        fb.gruppenId == this.formdata.selectedGroup) &&
                    el.name
                        .toLowerCase()
                        .includes(this.formdata.quicksearch.toLowerCase())
            )
        },
    },
    methods: {
        removeInstrument(id) {
            const index = this.anmeldung.instrumente.indexOf(id)
            if (index > -1) {
                this.anmeldung.instrumente.splice(index, 1)
            }
        },
        showNaechtigung() {
            return this.fortbildungtype.toLowerCase() == 'fw';
        },
        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get(this.fortbildungtype)
                .textbloeckePowerApps()
            this.formdata.textbausteine = data
        },
        async fetchTextbloecke() {
            const { data } = await this.service.fortbildungpowerapp.textbloecke(
                this.fortbildungtype
            )
            this.formdata.textbloecke = data
        },

        async fetchFortbildungen() {
            const { data } = await this.service.fortbildungpowerapp.alle(
                this.fortbildungtype
            )
            this.formdata.fortbildungen = data

            this.formdata.fortbildungen.sort((fa, fb) => new Date(fa.termine[0].von) - new Date(fb.termine[0].von))

            if (this.formdata.fortbildungen.length == 1) {
                this.formdata.fortbildungen[0].termine[0].isSelected = true;
            }

            if(this.formdata.fortbildungen.length == 0){
                this.formbehaviour.showNoModules = true;
            }
            
        },

        async fetchFortbildungsGruppen() {
            const { data } = await this.service.fortbildungsgruppepowerapp.alle()
            this.formdata.fortbildungsgruppen = data
        },

        async fetchMusikschulen() {
            var data = [];
            data.push.apply(data, (await this.service.fortbildungpowerapp.meta().musikschulen()).data);

            if(this.fortbildungtype.toLowerCase() == 'jf' || this.fortbildungtype.toLowerCase() == 'fw')
                data.push.apply(data, (await this.service.fortbildungpowerapp.meta().kreativakademien()).data);

            data.sort((a,b) => a.bezeichnung.localeCompare(b.bezeichnung));

            this.formdata.musikschulen = data;

            
        },

        async fetchInstrumente() {
            const { data } = await this.service.fortbildungpowerapp.meta().instrumente()
            this.formdata.instrumente = data
        },

        async sendAnmeldung() {
            try {
                this.anmeldung.anmeldungen = []

                this.formdata.fortbildungen.forEach(fortbildung => {
                    fortbildung.termine.forEach(termin => {
                        if (!termin.isSelected) return

                        var fortbildungElement = this.anmeldung.anmeldungen.find(
                            am => am.fortbildungsId == fortbildung.id
                        )

                        if (!fortbildungElement)
                            this.anmeldung.anmeldungen.push({
                                fortbildungsId: fortbildung.id,
                                termine: [termin.id],
                            })
                        else fortbildungElement.termine.push(termin.id)
                    })
                })

                this.formbehaviour.sending = true
                await this.service.formular.senden(
                    'powerapp/fortbildung',
                    this.anmeldung
                )
                this.formbehaviour.showSendModal = false
                this.formbehaviour.successful = true
            } catch (error) {
                console.log(Object.keys(error), error.message)
            } finally {
                this.formbehaviour.sending = false
            }
        },

        getGroupName(gruppeId) {
            let group = this.formdata.fortbildungsgruppen.find(
                el => el.id == gruppeId
            );

            if (group == null)
                return '';

            return group.name;
        },

        getZeitraum(module){
            let von = new Date(module.von);
            let bis = new Date(module.bis);

            return `${von.toLocaleString('de-AT', { year: 'numeric', month: 'numeric', day: 'numeric' })} ${von.toLocaleString('de-AT', { hour: '2-digit', minute: '2-digit' })}-${bis.toLocaleString('de-AT', { year: 'numeric', month: 'numeric', day: 'numeric' })} ${bis.toLocaleString('de-AT', { hour: '2-digit', minute: '2-digit' })}`;
        },

        getLabelForInstitution(){
            if(this.fortbildungtype.toLowerCase() == 'lf')
                return 'Musikschule';
            if(this.fortbildungtype.toLowerCase() == 'kd')
                return 'Musikschule / Musik- und Kunstschule';

            return 'Musikschule / Kreativakademie';
        },

        showAndereInstitution(){
            if(this.fortbildungtype.toLowerCase() == 'lf')
                return true;
            if(this.fortbildungtype.toLowerCase() == 'kd')
                return false;

            return true;
        },

        openSubmitModal() {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    window.scrollTo(0, 0)
                    this.formbehaviour.alertrequired = true
                    return
                }

                this.formbehaviour.showSendModal = true
            })
        },

        textbausteinfuer(id) {
            if (!this.formdata.textbausteine) return

            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found.content
        },

        async initData() {
            this.fetchMusikschulen()
            this.fetchTextBausteine()
            this.fetchInstrumente()
            this.fetchFortbildungsGruppen()
            this.fetchFortbildungen()
            this.fetchTextbloecke()
        },
    },
    created() {
        this.initData()
    },
    beforeDestroy() { },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
